import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import AvatarButton from '../components/avn-button'

export const UserCheckinWarning = (props) => {
  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
    >
      <DialogContent className='avn-modal-content-container'>
        <p style={{padding: '12px 0px'}}>Since the user last checked in {props.daysAfterLastCheckIn} days ago, they'll need to check in again before you can edit this setting. That's because any change to calories will require a new starting weight, and they're {props.daysAfterLastCheckIn >= 7 ? 'already due' : 'almost due'} for their next check-in now.</p>
      </DialogContent>
      <DialogActions>
        <div className='avn-button-save-container'>
          <AvatarButton className='avn-action-button'
            id='avn-action-card'
            message='Close'
            onClick={props.onClose}
          />
        </div>
      </DialogActions>
    </Dialog>
  );
};
